'use client';
import Image from '@repo/ui/src/components/Image';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { cTAClicked, productClicked } from '@repo/ui/src/services/analytics';
import { basketLineInputToAnalytics } from '@repo/ui/src/services/analytics/factories';
import { LineItem } from '@repo/ui/src/types/lineItem';
import { OrderRowBodyProps } from '@views/Account/OrderRowBody';
import React from 'react';

export interface OrderLineItemProps
  extends Omit<
    OrderRowBodyProps,
    'giftCardLink' | 'giftCertificateItems' | 'getCurrencyString' | 'productItems'
  > {
  lineItem: LineItem;
  index: number;
}

const OrderLineItem = ({
  lineItem,
  index,
  quantityText,
  reviewLinkText,
  hideReviewLink = false,
  isAccountPage = false,
}: OrderLineItemProps) => {
  const { locale } = useCurrentUrl();
  const lineItemImage = lineItem?.image;
  return (
    <li className="tw-bg-white tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-p-4 md:tw-py-5 md:tw-px-6 tw-gap-4 md:tw-gap-10">
      {lineItemImage ? (
        <Image
          src={lineItemImage}
          width={100}
          height={100}
          objectFit="contain"
          alt={lineItem.title}
        />
      ) : (
        <div className="tw-w-[100px] tw-aspect-square tw-bg-warm-200 tw-rounded-sm" />
      )}
      <div className="md:tw-flex md:tw-flex-row tw-w-full md:tw-justify-between tw-gap-x-4">
        <div>
          {lineItem.productUrl ? (
            <Anchor
              link={lineItem.productUrl}
              className="tra-text-web-body-m-link tw-font-bold"
              onClick={() => {
                productClicked({
                  affiliation: 'website',
                  locale,
                  brand: 'Traeger',
                  basket_token: '',
                  currency: '',
                  ...basketLineInputToAnalytics(lineItem, index),
                });
              }}
            >
              {lineItem.title}
            </Anchor>
          ) : (
            <p className="tra-text-web-body-m tw-font-bold">{lineItem.title}</p>
          )}
          <p className="tw-my-2 md:tw-mt-3 tra-text-web-body-m">
            {quantityText} {lineItem.quantity}
          </p>
        </div>
        <div className="tw-flex tw-gap-3 md:tw-flex-col">
          {!hideReviewLink && lineItem.sku && (
            <button
              className="tra-text-web-body-m-link"
              onClick={() => {
                window.$BV.ui('rr', 'submit_review', { productId: lineItem.sku });
                cTAClicked({
                  affiliation: 'website',
                  brand: 'Traeger',
                  locale,
                  cta_location: isAccountPage ? 'my account_order history' : 'order_tracking',
                  cta_text: reviewLinkText,
                  cta_type: 'button',
                });
              }}
            >
              {reviewLinkText}
            </button>
          )}
        </div>
      </div>
    </li>
  );
};

export default OrderLineItem;
